import { useEffect } from "react";
import { Navigate, Outlet, Route, Routes, useNavigate } from "react-router-dom";
import { ROLE } from "../../data/enums";
import api from "../../utils/api";
import { AppContent } from "./Styled";

import DashboardDetail from "../../widgets/Dashboard/detail";
import ProtectedRoute from "./ProtectedRoute";

import CreateProduct from "../../widgets/Product/create";
import ProductDetail from "../../widgets/Product/detail";
import Products from "../../widgets/Products";

import CreateMaterial from "../../widgets/Material/create";
import MaterialDetail from "../../widgets/Material/detail";
import MaterialList from "../../widgets/MaterialList";

import CreateAddOn from "../../widgets/AddOn/create";
import AddOnDetail from "../../widgets/AddOn/detail";
import AddOns from "../../widgets/AddOns";

import CreateExtraFee from "../../widgets/ExtraFee/create";
import ExtraFeeDetail from "../../widgets/ExtraFee/detail";
import ExtraFees from "../../widgets/ExtraFees";

import CreateProductOrder from "../../widgets/ProductOrder/create";
import ProductOrder from "../../widgets/ProductOrders";

import { CreateMaterialOrder } from "../../widgets/MaterialOrder/create";
import { MaterialOrderDetail } from "../../widgets/MaterialOrder/detail";
import MaterialOrder from "../../widgets/MaterialOrders";

import { CreateMaterialRequest } from "../../widgets/MaterialRequest/create";
import MaterialRequest from "../../widgets/MaterialRequests";

import { CreateOutsourceOrder } from "../../widgets/OutsourceOrder/create";
import { OutsourceOrderDetail } from "../../widgets/OutsourceOrder/detail";
import OutsourceOrder from "../../widgets/OutsourceOrderList";

import CreateCustomer from "../../widgets/Customer/create";
import CustomerDetail from "../../widgets/Customer/detail";
import CustomerList from "../../widgets/CustomerList";

import CreateProvider from "../../widgets/Provider/create";
import ProviderDetail from "../../widgets/Provider/detail";
import ProviderList from "../../widgets/ProviderList";

import UserList from "../../widgets/UserList";
import UserProfile from "../../widgets/UserProfile/detail";

import CreateKpi from "../../widgets/Kpi/create";
import KpiDetail from "../../widgets/Kpi/detail";
import KpiList from "../../widgets/KpiList";

import DeliveryTrips from "../../widgets/DeliveryTrips";
import FileList from "../../widgets/FileList";
import VersionDisplay from "../../widgets/VersionDisplay";

import CreateAccountingAccount from "../../widgets/AccountingAccount/create";
import AccountingAccountDetail from "../../widgets/AccountingAccount/detail";
import AccountingAccounts from "../../widgets/AccountingAccounts";
import Audit from "../../widgets/Audit";
import Import from "../../widgets/Import";
import { MaterialRequestDetail } from "../../widgets/MaterialRequest/detail";
import SaleOrderDetail from "../../widgets/SaleOrder/detail";
import CreateUserProfile from "../../widgets/UserProfile/create";
import { OUTSOURCE_ORDER_CREATE_ROLES } from "../../configs/outsourceOrderPermissions";


const Content = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleApiPost = async (path: string, endpoint: string) => {
            if (window.location.pathname === path) {
                try {
                    const response = await api.post(endpoint);
                    navigate("/");
                } catch (error) {
                    console.error("Error:", error);
                }
            }
        };

        handleApiPost("/utils/reset", "/utils/reset-test-server");
        handleApiPost("/utils/dumpdata", "/utils/dumpdata");
    }, [navigate]);

    return (
        <AppContent>
            <Routes>
                <Route
                    path="/"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.ACCOUNTANT_MANAGER,
                                ROLE.SALE_MANAGER,
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.LOGISTIC_STAFF,
                                ROLE.PRODUCTION_STAFF,
                                ROLE.PURCHASING_STAFF,
                                ROLE.SALE_STAFF,
                                ROLE.STORAGE_KEEPER,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                            ]}
                        />
                    }
                >
                    <Route path="" element={<DashboardDetail />} />
                </Route>

                {/** Utils route */}
                <Route
                    path="/utils/reset"
                    element={<div>Resetting in 5 seconds...</div>}
                />
                <Route
                    path="/utils/dumpdata"
                    element={
                        <div>
                            Dumping current data, this will overwrite the
                            current dumped data...
                        </div>
                    }
                />
                <Route
                    path="/utils/import"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="" element={<Import />} />
                </Route>

                {/** Accounting Accounts route */}
                <Route
                    path="/accounting-accounts/*"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.ACCOUNTANT_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="" element={<AccountingAccounts />} />
                    <Route
                        path="create"
                        element={<CreateAccountingAccount />}
                    />
                    <Route
                        path=":accountingAccountId"
                        element={<AccountingAccountDetail />}
                    />
                </Route>

                {/** Product route  **/}
                <Route
                    path="/products/*"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.ACCOUNTANT_MANAGER,
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.LOGISTIC_STAFF,
                                ROLE.SALE_MANAGER,
                                ROLE.SALE_STAFF,
                                ROLE.STORAGE_KEEPER,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.PRODUCTION_STAFF,
                                ROLE.PURCHASING_STAFF,
                                ROLE.FACTORY_MANAGER_ONE,
                                ROLE.FACTORY_MANAGER_TWO,
                                ROLE.DEPUTY_FACTORY_MANAGER_ONE,
                                ROLE.DEPUTY_FACTORY_MANAGER_TWO,
                            ]}
                        />
                    }
                >
                    <Route path="" element={<Products />} />
                    <Route path="create" element={<CreateProduct />} />
                    <Route path=":productId" element={<ProductDetail />} />
                </Route>

                {/** Customer route  **/}
                <Route
                    path="/customers/*"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.LOGISTIC_STAFF,
                                ROLE.SALE_MANAGER,
                                ROLE.SALE_STAFF,
                                ROLE.STORAGE_KEEPER,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.PRODUCTION_STAFF,
                                ROLE.PURCHASING_STAFF,
                                ROLE.ACCOUNTANT_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="" element={<CustomerList />} />
                    <Route path="create" element={<CreateCustomer />} />
                    <Route path=":customerId" element={<CustomerDetail />} />
                </Route>

                {/** Material route  **/}
                <Route
                    path="/"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.LOGISTIC_STAFF,
                                ROLE.SALE_MANAGER,
                                ROLE.SALE_STAFF,
                                ROLE.STORAGE_KEEPER,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.PRODUCTION_STAFF,
                                ROLE.PURCHASING_STAFF,
                                ROLE.ACCOUNTANT_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="/materials/*" element={<Outlet />}>
                        <Route path="" element={<MaterialList />} />
                        <Route path="create" element={<CreateMaterial />} />
                        <Route
                            path=":materialId"
                            element={<MaterialDetail />}
                        />
                    </Route>
                </Route>

                {/** Material orders route */}
                <Route
                    path="/material-orders/*"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.LOGISTIC_STAFF,
                                ROLE.SALE_MANAGER,
                                ROLE.PURCHASING_STAFF,
                                ROLE.PRODUCTION_STAFF,
                                ROLE.SALE_STAFF,
                                ROLE.STORAGE_KEEPER,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.ACCOUNTANT_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="" element={<MaterialOrder />} />
                    <Route path="create" element={<CreateMaterialOrder />} />
                    <Route
                        path=":materialOrderId"
                        element={<MaterialOrderDetail />}
                    />
                </Route>

                {/** Provider route**/}
                <Route
                    path="/"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.LOGISTIC_STAFF,
                                ROLE.SALE_MANAGER,
                                ROLE.SALE_STAFF,
                                ROLE.STORAGE_KEEPER,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.PRODUCTION_STAFF,
                                ROLE.PURCHASING_STAFF,
                                ROLE.ACCOUNTANT_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="/providers/*" element={<Outlet />}>
                        <Route path="" element={<ProviderList />} />
                        <Route path="create" element={<CreateProvider />} />
                        <Route
                            path=":providerId"
                            element={<ProviderDetail />}
                        />
                    </Route>
                </Route>

                {/** Addon route**/}
                <Route
                    path="/"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.LOGISTIC_STAFF,
                                ROLE.SALE_MANAGER,
                                ROLE.SALE_STAFF,
                                ROLE.STORAGE_KEEPER,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.PRODUCTION_STAFF,
                                ROLE.PURCHASING_STAFF,
                                ROLE.ACCOUNTANT_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="/addons/*" element={<Outlet />}>
                        <Route path="" element={<AddOns />} />
                        <Route path="create" element={<CreateAddOn />} />
                        <Route path=":addOnId" element={<AddOnDetail />} />
                    </Route>
                </Route>

                {/** Delivery trips route**/}
                <Route
                    path="/"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.PRODUCTION_STAFF,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.SALE_STAFF,
                                ROLE.SALE_MANAGER,
                                ROLE.STORAGE_KEEPER,
                                ROLE.ACCOUNTANT_MANAGER,
                                ROLE.FACTORY_MANAGER_ONE,
                                ROLE.FACTORY_MANAGER_TWO,
                                ROLE.DEPUTY_FACTORY_MANAGER_ONE,
                                ROLE.DEPUTY_FACTORY_MANAGER_TWO,
                            ]}
                        />
                    }
                >
                    <Route
                        path="/api/product-flow/v2/delivery-trips/grouped/"
                        element={<Outlet />}
                    >
                        <Route path="" element={<DeliveryTrips />} />
                    </Route>
                </Route>

                {/** Extra Fee **/}
                <Route
                    path="/"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.LOGISTIC_STAFF,
                                ROLE.SALE_STAFF,
                                ROLE.SALE_MANAGER,
                                ROLE.STORAGE_KEEPER,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.PRODUCTION_STAFF,
                                ROLE.PURCHASING_STAFF,
                                ROLE.ACCOUNTANT_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="/extrafees/*" element={<Outlet />}>
                        <Route path="" element={<ExtraFees />} />
                        <Route path="create" element={<CreateExtraFee />} />
                        <Route
                            path=":extraFeeId"
                            element={<ExtraFeeDetail />}
                        />
                    </Route>
                </Route>

                {/** Product orders route */}
                <Route path="/product-orders/*" element={<Outlet />}>
                    <Route path="" element={<ProductOrder />} />
                    <Route path="create" element={<CreateProductOrder />} />
                    <Route path=":productOrderId" element={<SaleOrderDetail />} />
                </Route>

                {/** Material orders route */}
                <Route
                    path="/material-orders/*"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.LOGISTIC_STAFF,
                                ROLE.SALE_MANAGER,
                                ROLE.SALE_STAFF,
                                ROLE.STORAGE_KEEPER,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.ACCOUNTANT_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="" element={<MaterialOrder />} />
                    <Route path="create" element={<CreateMaterialOrder />} />
                    <Route
                        path=":materialOrderId"
                        element={<MaterialOrderDetail />}
                    />
                </Route>

                {/** Material requests route */}
                <Route
                    path="/material-requests/*"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.STORAGE_KEEPER,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.FACTORY_STAFF,
                                ROLE.FACTORY_MANAGER_ONE,
                                ROLE.FACTORY_MANAGER_TWO,
                                ROLE.DEPUTY_FACTORY_MANAGER_ONE,
                                ROLE.DEPUTY_FACTORY_MANAGER_TWO,
                            ]}
                        />
                    }
                >
                    <Route path="" element={<MaterialRequest />} />
                    <Route path="create" element={<CreateMaterialRequest />} />
                    <Route
                        path=":materialRequestId"
                        element={<MaterialRequestDetail />}
                    />
                </Route>

                {/** Outsource orders route */}
                <Route
                    path="/outsource-orders/*"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.LOGISTIC_STAFF,
                                ROLE.SALE_MANAGER,
                                ROLE.SALE_STAFF,
                                ROLE.STORAGE_KEEPER,
                                ROLE.PURCHASING_STAFF,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.ACCOUNTANT_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="" element={<OutsourceOrder />} />
                    <Route
                        element={
                            <ProtectedRoute
                                allowedRoles={OUTSOURCE_ORDER_CREATE_ROLES}
                            />
                        }
                    >
                        <Route path="create" element={<CreateOutsourceOrder />} />
                    </Route>
                    <Route
                        path=":outsourceOrderId"
                        element={<OutsourceOrderDetail />}
                    />
                </Route>

                {/** User route**/}
                <Route
                    path="/"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.LOGISTIC_STAFF,
                                ROLE.SALE_MANAGER,
                                ROLE.SALE_STAFF,
                                ROLE.STORAGE_KEEPER,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.FACTORY_MANAGER_ONE,
                                ROLE.FACTORY_MANAGER_TWO,
                                ROLE.DEPUTY_FACTORY_MANAGER_ONE,
                                ROLE.DEPUTY_FACTORY_MANAGER_TWO,
                                ROLE.PRODUCTION_STAFF,
                                ROLE.PURCHASING_STAFF,
                                ROLE.ACCOUNTANT_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="/users/*" element={<Outlet />}>
                        <Route path="" element={<UserList />} />
                        <Route path="create" element={<CreateUserProfile />} />
                        <Route path=":userId" element={<UserProfile />} />
                    </Route>
                </Route>

                {/** KPI route**/}
                <Route
                    path="/"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.LOGISTIC_STAFF,
                                ROLE.SALE_STAFF,
                                ROLE.SALE_MANAGER,
                                ROLE.STORAGE_KEEPER,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.PRODUCTION_STAFF,
                                ROLE.PURCHASING_STAFF,
                                ROLE.ACCOUNTANT_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="/kpis/*" element={<Outlet />}>
                        <Route path="" element={<KpiList />} />
                        <Route path="create" element={<CreateKpi />} />
                        <Route path=":kpiId" element={<KpiDetail />} />
                    </Route>
                </Route>

                {/** File route**/}
                <Route
                    path="/"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                                ROLE.LOGISTIC_STAFF,
                                ROLE.SALE_STAFF,
                                ROLE.SALE_MANAGER,
                                ROLE.STORAGE_KEEPER,
                                ROLE.FIRST_STORAGE_KEEPER,
                                ROLE.SECOND_STORAGE_KEEPER,
                                ROLE.DELIVERER,
                                ROLE.PRODUCTION_STAFF,
                                ROLE.PURCHASING_STAFF,
                                ROLE.ACCOUNTANT_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="/files/*" element={<Outlet />}>
                        <Route path="" element={<FileList />} />
                    </Route>
                </Route>

                {/** Version route - accessible to all authenticated users **/}
                <Route path="/version" element={<VersionDisplay />} />

                {/** Audit route */}
                <Route
                    path="/audit"
                    element={
                        <ProtectedRoute
                            allowedRoles={[
                                ROLE.MANAGER,
                                ROLE.LOGISTIC_MANAGER,
                            ]}
                        />
                    }
                >
                    <Route path="" element={<Audit />} />
                </Route>

                <Route
                    path="*"
                    element={<Navigate to={"/"} replace={true} />}
                />
            </Routes>
        </AppContent>
    );
};

export default Content;
